import { render, staticRenderFns } from "./ClientLandingPage.vue?vue&type=template&id=35ad0482&scoped=true"
import script from "./ClientLandingPage.vue?vue&type=script&lang=js"
export * from "./ClientLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ClientLandingPage.vue?vue&type=style&index=0&id=35ad0482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad0482",
  null
  
)

export default component.exports